__turbopack_context__.v({
  "form": "edit-scene-modal-module__3tLomq__form",
  "input": "edit-scene-modal-module__3tLomq__input",
  "inputTextArea": "edit-scene-modal-module__3tLomq__inputTextArea",
  "label": "edit-scene-modal-module__3tLomq__label",
});
